import { Chip } from '@mui/material';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { IOrderRerun } from '../../../types/api/response/orderrerunsresponse';

const sourceColor = (source: string): 'default' | 'primary' | 'secondary' => {
  switch (source) {
    case 'ADMIN_PANEL':
      return 'primary';
    case 'SUPERPRO':
      return 'secondary';
    default:
      return 'default';
  }
};

export const getOrderRerunsColumns = (): GridColDef[] => [
  {
    field: 'created_at',
    headerName: 'Timestamp',
    flex: 1.2,
    valueFormatter: (value: string) => (value ? new Date(value).toLocaleString() : '—'),
  },
  {
    field: 'reference',
    headerName: 'Order Reference',
    flex: 1,
    valueGetter: (_, row: IOrderRerun) => row.ds_order_number ?? row.order_number ?? '—',
  },
  {
    field: 'sequence',
    headerName: 'Attempt #',
    flex: 0.6,
  },
  {
    field: 'source',
    headerName: 'Source',
    flex: 0.8,
    renderCell: ({ value }: GridRenderCellParams) => (
      <Chip
        label={value === 'ADMIN_PANEL' ? 'Admin Panel' : value}
        size="small"
        color={sourceColor(value)}
      />
    ),
  },
  {
    field: 'kind',
    headerName: 'Kind',
    flex: 0.7,
    valueFormatter: (value: string | null) => value ?? '—',
  },
  {
    field: 'new_locus_order_id',
    headerName: 'New Locus Order Id',
    flex: 1.1,
  },
  {
    field: 'driver_name',
    headerName: 'Driver',
    flex: 0.9,
    valueFormatter: (value: string | null) => value ?? '—',
  },
  {
    field: 'requested_by',
    headerName: 'Requested By',
    flex: 0.9,
    valueFormatter: (value: string | null) => value ?? '—',
  },
  {
    field: 'reason',
    headerName: 'Reason',
    flex: 1.8,
    valueFormatter: (value: string | null) => value ?? '—',
  },
];
